import {FORM_FIELDS} from '@/constants/help/form';

// 파일 다운로드 링크
export const ILLEGAL_FILES = {
  hwp: '[별지_서식]_불법촬영물등_유통_신고_삭제요청서.hwp',
  docx: '[별지_서식]_불법촬영물등_유통_신고_삭제요청서.docx',
} as const;

export const ILLEGAL_FILE_HWP = encodeURIComponent(ILLEGAL_FILES.hwp);
export const ILLEGAL_FILE_DOCX = encodeURIComponent(ILLEGAL_FILES.docx);

export const ILLEGAL_FIELD_ORDER = [
  FORM_FIELDS.OS_INFO,
  FORM_FIELDS.MAIN_CATEGORY,
  FORM_FIELDS.SUB_CATEGORY,
  FORM_FIELDS.EMAIL,
  FORM_FIELDS.REPORTER_NAME,
  FORM_FIELDS.BIRTH,
  FORM_FIELDS.PHONE_NUMBER,
  FORM_FIELDS.TITLE,
  FORM_FIELDS.CONTENT,
  FORM_FIELDS.FILES,
  FORM_FIELDS.AGREEMENT,
];

// 불법촬영물등 유통 신고 > 카테고리
export const ILLEGAL_MAIN_CATEGORY = [
  {label: '불법촬영물등 유통신고', value: 'NODE0000000486'},
];

// 불법촬영물등 유통 신고 > content placeholder
export const ILLEGAL_DEFAULT_TEMPLATE = `신고 내용을 상세히 적어주시면 감사하겠습니다.\n\n※ 불법촬영물등의 위치를 특정할 수 있도록 URL과 화면 캡처본을 첨부하여 주시되 URL 기재가 어려울 경우 검색어 등 해당 불법촬영물등의 위치에 대한 상세 설명을 기재하여 주시기 바랍니다.`;
